if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"searchFormsClient","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(317|332|890)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}